import type { LocationEditWrapperProps } from "./location-edit.type";

import { useGetLocation } from "@/entities/location";
import FetchItemWrapper from "@/modules/fetch-item-wrapper";

import LocationEdit from "./location-edit.component";

const LocationEditWrapper = ({ locationId }: LocationEditWrapperProps) => {
  const { location, isLoading } = useGetLocation(locationId);

  return (
    <FetchItemWrapper
      item={location}
      loading={isLoading}
      renderContent={(location) => <LocationEdit location={location} />}
    />
  );
};

export default LocationEditWrapper;
